export function generateToolkitApplicationRptiNode(doc: Document): HTMLElement {
  const application = doc.createElement('Application');
  application.setAttribute('VendorName', 'Appraisify');
  application.setAttribute('ProductName', 'Toolkit');
  application.setAttribute('ProductVersion', '1.0.0');
  application.setAttribute('AixmlVersion', '1.5');

  return application;
}
